import React from "react";

export const tableCardStyle: React.CSSProperties = {
	background: "#fff",
	border: "1px solid #e5e7eb",
	borderRadius: 8,
	overflow: "hidden",
	marginBottom: 24,
	width: "70%",
};
export const headerCellStyle: React.CSSProperties = {
	padding: "10px 16px",
	background: "#00000005",
	borderBottom: "1px solid #0000000F",
	fontWeight: 600,
	fontSize: 13,
	color: "#666",
};
export const cellStyle: React.CSSProperties = {
	height: 54,
	maxHeight: 54,
	padding: "10px 16px",
	borderBottom: "1px solid #0000000F",
};
export const footerStyle: React.CSSProperties = {
	padding: "10px 16px",
	background: "#00000005",
	borderTop: "1px solid #0000000F",
};
export const addLinkStyle: React.CSSProperties = {
	color: "#4460ef",
	fontWeight: 600,
	cursor: "pointer",
	fontSize: 14,
	background: "none",
	border: "none",
	display: "flex",
	alignItems: "center",
	gap: 4,
};

export const modalBtnStyle = (active: boolean): React.CSSProperties => ({
	flex: 1,
	height: 48,
	borderRadius: 24,
	fontWeight: 600,
	fontSize: 16,
	background: active ? "#4460ef" : "#e0e0e0",
	color: active ? "#fff" : "#888",
	border: "none",
});
